var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCreateMachine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt_createMachine",
    transform: "translate(-2011.615 86.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2132",
    "data-name": "Rectangle 2132",
    width: 16,
    height: 13,
    rx: 2,
    transform: "translate(2011.615 -86.7)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2131",
    "data-name": "Rectangle 2131",
    width: 16,
    height: 13,
    rx: 2,
    transform: "translate(2013.615 -84.7)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2122",
    "data-name": "Rectangle 2122",
    transform: "translate(2015.615 -82.7)",
    fill: "#1424f9",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 12,
    rx: 1.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreateMachine);
export default __webpack_public_path__ + "static/media/ic_create_machine.1b49934df672c07ccc27699ac4155720.svg";
export { ForwardRef as ReactComponent };